/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5bf5470ef4c12cc22bc7f87b9d27f183e0d764ea";
